import { useCallback } from 'react';

const useTooltipPosition = () => {
  const calculateTooltipPosition = useCallback((targetElement) => {
    if (!targetElement) return { x: 0, y: 0 };
    
    const rect = targetElement.getBoundingClientRect();
    
    // Position tooltip to the left of the sidebar, with bounds checking
    let x = rect.left - 340; // 320px tooltip width + 20px gap
    let y = rect.top - 10;
    
    // Ensure tooltip doesn't go off the left edge
    if (x < 10) {
      x = 10;
    }
    
    // Ensure tooltip doesn't go off the top edge
    if (y < 10) {
      y = 10;
    }
    
    return { x, y };
  }, []);

  return { calculateTooltipPosition };
};

export default useTooltipPosition;
